<template>
        <navbar/>
        <main class="max-h-screen overflow-y-scroll relative smooth-scroll">
            <home></home>
            <aboutSection></aboutSection>
            <Services></Services>
            <portfolioSection></portfolioSection>
            <contactSection></contactSection>
        </main>
</template>

<script>
    import './assets/tailwind.css'
    import navbar from "./components/Navbar"
    import home from "./views/Home-section.vue"
    import aboutSection from "./views/About"
    import Services from "./views/Services"
    import portfolioSection from "./views/Portfolio"
    import contactSection from "./views/Contact"


    export default {
        name: 'App',
        components: {
            navbar,
            home,
            aboutSection,
            Services,
            portfolioSection,
            contactSection
        }
    }
</script>

<style>
    main{
        overflow: hidden;
    }

</style>
